document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#explore-gloves-slider', {
        width : '25vw',
        type        : 'loop',
        perPage: 1,
        breakpoints: {
            991: {
                width: '100vw',
                type        : 'loop',
                perPage: 1,
            },
        },
    }).mount();
});

document.addEventListener( 'DOMContentLoaded', function () {
    new Splide( '#explore-wraps-slider', {
        width : '25vw',
        type        : 'loop',
        perPage: 1,
        breakpoints: {
            991: {
                width: '100vw',
                type        : 'loop',
                perPage: 1,
            },
        },
    }).mount();
});